import { JQLLexer } from '@atlaskit/jql-parser';
import { errorMessages } from '../messages';

/**
 * Show the appropriate error message when parsing JQL fails and a field rule was expected.
 */
export var handleFieldRuleError = function handleFieldRuleError(currentToken, intl) {
  var isEOF = currentToken.type === JQLLexer.EOF;
  if (currentToken.type === JQLLexer.LBRACKET) {
    return intl.formatMessage(errorMessages.expectingCFButReceived);
  }
  return isEOF ? intl.formatMessage(errorMessages.expectingFieldBeforeEOF) : intl.formatMessage(errorMessages.expectingFieldButReceived, {
    received: currentToken.text
  });
};